import React from "react";
import { Skeleton as MuiSkeleton } from "@mui/material";

export interface SkeletonProps {
  /** The type of content that will be rendered. */
  variant?: "text" | "circular" | "rectangular" | "rounded";
  /** Allows adding a custom class to the root of the component */
  className?: string;
  /** Sets the width of the component. If not set the component will adapt to the size of its children. */
  height?: number | string;
  /** Sets the width of the component. If not set the component will adapt to the width of its children. */
  width?: number | string;
  /** Optional children to infer height and width from */
  children?: React.ReactNode;
  /** Allows defining css style overrides */
  style?: React.CSSProperties;
}

/**
 * A content skeleton to use as a placeholder while waiting for data.
 * @param iProps SkeletonProps
 * @returns JSX representing the Skeleton component
 */
export const Skeleton = (iProps: SkeletonProps) => {
  const { variant, className, height, width, children, style } = iProps;

  return (
    <MuiSkeleton
      variant={variant}
      className={className}
      height={height}
      width={width}
      style={style}
    >
      {children}
    </MuiSkeleton>
  );
};
